/**
 * The marketing waitlist that sign-up points to while Registration Mode is Closed (SC-443).
 *
 * A platform admin sets it in Environment Config → Registration (`WorkspaceSettings.waitlist_url`);
 * unset means the Sevv website. The link opens in a new tab, so only https addresses are used:
 * cloud refuses anything else on save, and this check keeps a bad stored value from ever
 * reaching an `href`.
 */
export const DEFAULT_SIGNUP_WAITLIST_URL = 'https://sevv.com'

/** The address as it will be used, or null when it is not a full https URL. */
export function normalizeWaitlistUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null
  const trimmed = value.trim()
  if (!trimmed) return null
  try {
    const url = new URL(trimmed)
    return url.protocol === 'https:' && url.hostname ? url.href : null
  } catch {
    return null
  }
}

/** The admin's field: empty is fine (the default is used), anything else must be https. */
export function waitlistUrlInputError(value: string | undefined): string | undefined {
  if (!value || !value.trim()) return undefined
  return normalizeWaitlistUrl(value) ? undefined : 'Enter a full https:// address'
}

export function signupWaitlistUrl(settings: { waitlist_url?: unknown } | null | undefined): string {
  return normalizeWaitlistUrl(settings?.waitlist_url) ?? DEFAULT_SIGNUP_WAITLIST_URL
}
